import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { keycloak } from './services/keycloakService';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { initializeApiClient } from './services/apiConfig';
import { LoginScreen } from 'screens';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const onKeycloakEvent = (event: string) => {
  console.log('Keycloak event:', event);
  if (event === 'onReady') {
    initializeApiClient(keycloak);
  }
};

const keycloakProviderInitConfig = {
  // onLoad: 'check-sso',
  // silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  responseMode: 'query',
};

const renderApp = () => {
  root.render(
    <ReactKeycloakProvider 
      authClient={keycloak}
      initOptions={keycloakProviderInitConfig}
      LoadingComponent={<div>Loading KC...</div>}
      onEvent={onKeycloakEvent}
    >
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ReactKeycloakProvider>
  );
};

renderApp();

reportWebVitals(console.log);